import React from 'react'
import { Query } from 'react-apollo'

import cliente from 'graphql/queries/cliente'
import miniMe from 'graphql/queries/miniMe'

import Dati from './Dati'
import Azioni from './Azioni'

// core components
import RegularCard from 'components/Cards/RegularCard.jsx'
import NavPills from 'components/NavPills/NavPills.jsx'

class DettaglioCliente extends React.Component {
  render() {
    return (
      <Query
        query={cliente}
        variables={{
          where: {
            id: parseInt(this.props.match.params.id, 10),
          },
          azioniOrderBy: ['dataOra_DESC'],
        }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data, refetch }) => {
          if (loading) return <p>Loading...</p>
          if (error) return <p>Error :(</p>

          const cliente = data.cliente

          // if (window.ps) {
          //   window.ps.update()
          // }

          return (
            <Query query={miniMe}>
              {({ loading, error, data: { me } }) => {
                if (loading) return <p>Loading...</p>
                if (error) return <p>Error :(</p>

                return (
                  <RegularCard
                    cardTitle={
                      <div>
                        <h3 style={{ display: 'inline-block' }}>
                          {cliente.nome}{' '}
                          <small style={{ fontSize: '14px', color: '#777' }}>
                            (COD. {cliente.id})
                          </small>
                        </h3>
                        {!!cliente.daRicontattare && (
                          <h4
                            style={{
                              display: 'inline-block',
                              float: 'right',
                              margin: '30px 30px 0 10px',
                              color: '#f50057',
                            }}
                          >
                            <b>Da ricontattare</b>
                          </h4>
                        )}
                      </div>
                    }
                    content={
                      <NavPills
                        color="warning"
                        tabs={[
                          {
                            tabButton: 'Dati',
                            tabContent: (
                              <Dati
                                cliente={cliente}
                                canDeleteCustomer={
                                  me.ruolo === 'SEGRETARIA' || me.ruolo === 'ADMIN'
                                }
                                history={this.props.history}
                                isAgente={me.ruolo === 'AGENTE'}
                                utenteId={me.id}
                              />
                            ),
                          },
                          {
                            tabButton: 'Azioni',
                            tabContent: (
                              <Azioni
                                azioni={cliente.azioni}
                                clienteId={cliente.id}
                                agenteId={me.ruolo === 'AGENTE' ? me.id : cliente.agenteId}
                                utenteId={me.id}
                                isAgente={me.ruolo === 'AGENTE'}
                                canCreateForm={me.ruolo === 'SEGRETARIA' || me.ruolo === 'ADMIN'}
                              />
                            ),
                          },
                        ]}
                      />
                    }
                  />
                )
              }}
            </Query>
          )
        }}
      </Query>
    )
  }
}

export default DettaglioCliente



// WEBPACK FOOTER //
// ./src/views/App/Clienti/DettaglioCliente.jsx